import {useEffect, useState} from "react";
import valuer_api from "../../api/valuer";
import ValuerAmendTableScreenshotUploader from "./table/ValuerAmendTableScreenshotUploader";
import ValuerAmendTableScreenshotPreview from "./table/ValuerAmendTableScreenshotPreview";
import ValuerAmendTableFreeText from "./table/ValuerAmendTableFreeText";
import ValuerAmendTableSizeColumn from "./table/ValuerAmendTableSizeColumn";
import ValuerAmendTablePrice from "./table/ValuerAmendTablePrice";


const ValueAmendTableContainer = (props) => {

    // For Saving
    const summaryId = props.summaryId
    const section = props.sectionName
    const identifier = props.identifier

    // Required
    const rows = props.rows
    const columns = props.columns

    // Sizing
    const rowHeight = props.rowHeight ? props.rowHeight : '48px'

    // Value
    const [values, setValues] = useState([])
    const [fileVersion, setFileVersion] = useState(0); // <-- track changes to file data

    // Saving Tracker
    const UpdateParentValue = props.UpdateParentValue
    const AddToQueue = props.AddToQueue
    const RemoveFromQueue = props.RemoveFromQueue
    const AddToErroredSaves = props.AddToErroredSaves

    // Error Handling
    const setErrorMessage = props.setErrorMessage
    const setErrorTitle = props.setErrorTitle

    const placeholder = ""

    useEffect(() => {
        if (props.values === undefined) return
        setValues(props.values)
    }, [props.values])

    useEffect(() => {
        if (section === "property-details-section" || section === "accommodation-section") {
            const fetchFiles = async () => {
                try {
                    const resp = await valuer_api.ValuerAmendFileGet(summaryId, section, 'image');
                    resp.data.files.forEach((file) => {
                        const file_path = file.path;
                        const filename = file.filename;
                        const file_data = file.file_data;
                        const rowIdentifier = file.file_row;

                        const pathParts = file_path.split('/');
                        const columnIdentifier = pathParts[2] // Gives us 'images'

                        const entry = {
                            file_path,
                            filename,
                            file_data
                        };

                        // Patch into state
                        setValues(prev => {
                            const updated = { ...prev };
                            resp.data.files.forEach(file => {
                                const file_path = file.path;
                                const filename = file.filename;
                                const file_data = file.file_data;
                                const rowIdentifier = file.file_row;
                                const pathParts = file_path.split('/');
                                const columnIdentifier = pathParts[2];
                                const entry = { file_path, filename, file_data };

                                if (!updated[rowIdentifier]) updated[rowIdentifier] = {};
                                updated[rowIdentifier][columnIdentifier] = entry;
                            });
                            return updated;
                        });
                        setFileVersion(prev => prev + 1); // trigger rerender

                    });


                } catch (err) {
                    console.error("Error fetching files:", err);
                }
            };

            fetchFiles();
        }
    }, [section, summaryId, identifier]);

    const PatchLocalFileValue = (row, column, fileObject) => {
        setValues(prev => {
            const updated = { ...prev };
            if (!updated[row]) updated[row] = {};
            updated[row][column] = fileObject;
            return updated;
        });
        setFileVersion(prev => prev + 1); // force re-render of preview
    };


    return (
        <div className="valuer-amend-table-field-container">
            <div className="valuer-amend-table">
                <div className="valuer-amend-table-row-container">
                    {columns && columns.map((column, idx) => {
                        return (
                            <div className={"valuer-amend-table-field-column-container title" + (idx === 0 ? ' left' : '')}
                                style={{width: column.width}}>
                                {column.label}
                            </div>
                        )
                    })}
                </div>
                {rows && rows.map((row, idx) => {
                    return (
                        <div className={"valuer-amend-table-row-container" + (idx === rows.length - 1 ? ' bottom' : '')}>
                            {columns && columns.map((column, idx) => {
                                return (
                                    <div className={"valuer-amend-table-field-column-container" + (idx === 0 ? ' left' : '')}
                                         style={{width: column.width}}>
                                        {row.disabled_fields && row.disabled_fields.includes(column.identifier)
                                            ? <div className="disabled-table-field" />
                                            : (column.type === "title"
                                                ? <div className="table-label-field">{row.label}</div>
                                                : (column.type === "freetext"
                                                    ? <ValuerAmendTableFreeText summaryId={summaryId}
                                                                                section={section}
                                                                                identifier={identifier}
                                                                                textLimit={column.textLimit}
                                                                                columnIdentifier={column.identifier}
                                                                                rowIdentifier={row.identifier}
                                                                                rowValues={values && values[row.identifier]}
                                                                                UpdateParentValue={UpdateParentValue}
                                                                                AddToQueue={AddToQueue}
                                                                                RemoveFromQueue={RemoveFromQueue}
                                                                                AddToErroredSaves={AddToErroredSaves}
                                                                                setErrorMessage={setErrorMessage}
                                                                                setErrorTitle={setErrorTitle} />
                                                    : (column.type === "size"
                                                        ? <ValuerAmendTableSizeColumn summaryId={summaryId}
                                                                                      section={section}
                                                                                      identifier={identifier}
                                                                                      columnIdentifiers={column.identifiers}
                                                                                      addedText={column.addedText}
                                                                                      rowIdentifier={row.identifier}
                                                                                      rowValues={values && values[row.identifier]}
                                                                                      UpdateParentValue={UpdateParentValue}
                                                                                      AddToQueue={AddToQueue}
                                                                                      RemoveFromQueue={RemoveFromQueue}
                                                                                      AddToErroredSaves={AddToErroredSaves}
                                                                                      setErrorMessage={setErrorMessage}
                                                                                      setErrorTitle={setErrorTitle} />
                                                        : (column.type === "screenshot-upload"
                                                            ? <ValuerAmendTableScreenshotUploader summaryId={summaryId}
                                                                                                  section={section}
                                                                                                  identifier={identifier}
                                                                                                  columnIdentifier={column.identifier}
                                                                                                  rowIdentifier={row.identifier}
                                                                                                  rowValues={values && values[row.identifier]}
                                                                                                  placeholder={
                                                                                                      values &&
                                                                                                      values[row.identifier] &&
                                                                                                      values[row.identifier][column.identifier] &&
                                                                                                      values[row.identifier][column.identifier]["filename"]
                                                                                                          ? values[row.identifier][column.identifier]["filename"]
                                                                                                          : (values && values[row.identifier] ? "paste screenshot here" : "")
                                                                                                  }
                                                                                                  UpdateParentValue={UpdateParentValue}
                                                                                                  PatchLocalFileValue={PatchLocalFileValue}
                                                                                                  AddToQueue={AddToQueue}
                                                                                                  RemoveFromQueue={RemoveFromQueue}
                                                                                                  AddToErroredSaves={AddToErroredSaves}
                                                                                                  setErrorMessage={setErrorMessage}
                                                                                                  setErrorTitle={setErrorTitle}
                                                                                                  fileVersion = {fileVersion} />
                                                            : (column.type === "screenshot-preview"
                                                                ? <ValuerAmendTableScreenshotPreview summaryId={summaryId}
                                                                                                     section={section}
                                                                                                     identifier={identifier}
                                                                                                     columnIdentifier={column.identifier}
                                                                                                     rowIdentifier={row.identifier}
                                                                                                     rowValues={values && values[row.identifier]}
                                                                                                     UpdateParentValue={UpdateParentValue}
                                                                                                     AddToQueue={AddToQueue}
                                                                                                     RemoveFromQueue={RemoveFromQueue}
                                                                                                     AddToErroredSaves={AddToErroredSaves}
                                                                                                     setErrorMessage={setErrorMessage}
                                                                                                     setErrorTitle={setErrorTitle}
                                                                                                     fileVersion = {fileVersion} />
                                                                : (column.type === "price"
                                                                    ? <ValuerAmendTablePrice summaryId={summaryId}
                                                                                             section={section}
                                                                                             identifier={identifier}
                                                                                             textLimit={column.textLimit}
                                                                                             columnIdentifier={column.identifier}
                                                                                             rowIdentifier={row.identifier}
                                                                                             rowValues={values && values[row.identifier]}
                                                                                             UpdateParentValue={UpdateParentValue}
                                                                                             AddToQueue={AddToQueue}
                                                                                             RemoveFromQueue={RemoveFromQueue}
                                                                                             AddToErroredSaves={AddToErroredSaves}
                                                                                             setErrorMessage={setErrorMessage}
                                                                                             setErrorTitle={setErrorTitle} />
                                                                    : null
                                                                )
                                                            )
                                                        )
                                                    )
                                                )
                                            )
                                        }
                                    </div>
                                )
                            })}
                        </div>
                    )
                })}
            </div>
        </div>
    )
}


export default ValueAmendTableContainer